export default "__VITE_ASSET__74974388__"